import React, { Component } from 'react'
import Layout from '../components/Layout'

export default class NotFound extends Component {
  render() {
    return <Layout>Esta página não existe.</Layout>
  }
}



// WEBPACK FOOTER //
// ./src/containers/NotFound.js